import { AbstractControl, ValidatorFn } from '@angular/forms';
import { PredicateFn } from '@fmnts/core';

/**
 * Composes a new validator from a given `validator`
 * that will be evaluated if the given `predicate` is fulfilled.
 *
 * @param validator Validator function
 * @param predicate Predicate function
 *
 * @returns
 * A new validator function
 */
export function predicateValidator(
  validator: ValidatorFn,
  predicate: PredicateFn<AbstractControl>,
): ValidatorFn {
  return (control) => (predicate(control) ? validator(control) : null);
}
